export type CreatorUrlType = "subdomain" | "path";

export type CreatorDomain = "browsable.ai" | "browsable.bio";

function getPreferredProtocol(): "http" | "https" {
  try {
    return window.location.protocol === "http:" ? "http" : "https";
  } catch (_e) {
    return "https";
  }
}

export function isBrowsablePlatformDomain(domain: string): boolean {
  const d = String(domain || "")
    .trim()
    .toLowerCase()
    .replace(/^https?:\/\//, "")
    .replace(/^www\./, "")
    .replace(/\/+$/, "");
  return d === "browsable.ai" || d === "browsable.bio";
}

export function buildCreatorPublicUrl(args: {
  username: string;
  urlType?: CreatorUrlType | null;
  domain?: CreatorDomain | string | null;
}): string {
  const username = String(args.username || "").trim();
  // Legacy/default behavior:
  // - Existing creators without a saved preference stay on browsable.ai/{username}
  // - New creators can choose subdomain/path + domain (ai/bio)
  const urlType = (args.urlType || "path") as CreatorUrlType;
  const domain = String(args.domain || "browsable.ai").trim();

  if (!username) return "";
  const protocol = getPreferredProtocol();

  // Custom domains are the site root — no /{username}.
  if (!isBrowsablePlatformDomain(domain)) {
    return `${protocol}://${domain}`;
  }

  if (urlType === "path") {
    return `${protocol}://${domain}/${encodeURIComponent(username)}`;
  }

  try {
    const host = String(
      typeof window !== "undefined" ? window.location.hostname : "",
    ).toLowerCase();
    if (host.endsWith(".localhost") || host === "localhost") {
      const port =
        typeof window !== "undefined" && window.location.port
          ? `:${window.location.port}`
          : "";
      return `${protocol}://${encodeURIComponent(username)}.localhost${port}`;
    }
  } catch (_e) {
    // ignore
  }

  return `${protocol}://${username}.${domain}`;
}

